import { css } from 'styled-components/macro'
import { keyframes } from 'styled-components'

export const rotateSequence = keyframes`
    from {
        transform: rotate(0deg);
    } 

    to {
        transform: rotate(360deg);
    } 
`

export const slideInSequence = keyframes`
    from {
        transform: translateY(20px);
    }
    to {
        transform: translateY(0);
    }
`

export const fadeInSequence = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`

export const fadeInOnRender = () => css`
    animation: ${fadeInSequence} 0.2s ease-in-out;
`
